// src/sectors/pilates/settings/tabs/notifications/NotificationsRow.jsx
import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export function NotificationsRow({ label, hint, right }) {
  return (
    <MDBox
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        py: 0.9,
      }}
    >
      <MDBox sx={{ minWidth: 0 }}>
        <MDTypography variant="button" fontWeight="bold" sx={{ lineHeight: 1.15 }}>
          {label}
        </MDTypography>
        {hint ? (
          <MDTypography
            variant="caption"
            sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.25 }}
          >
            {hint}
          </MDTypography>
        ) : null}
      </MDBox>

      <MDBox sx={{ flex: '0 0 auto' }}>{right}</MDBox>
    </MDBox>
  );
}
